import React from "react";
import styled, { css } from "styled-components";
import { Colors } from "../../config";
import { Error } from "../../config/StyledComponents";
import InputLabel from "../InputLabel";

const hideIcon = require("../../assets/images/Hide.png");
const showIcon = require("../../assets/images/Show.png");

const LoginInputfield = ({
  value,
  onChange,
  name,
  label,
  placeholder,
  type,
  errorText,
  disabled,
  showHidePassword,
  setShowHidePassword,
}) => {
  const inputType =
    type === "password" ? (showHidePassword ? "text" : "password") : "text";
  return (
    <LoginInputWrapper>
      <InputLabel
        label={label}
        isRounded={true}
        labelFontColor={Colors.coolGrey}
        labelFontWeight="400"
      />
      <InputAndPasswordWrapper userType={type} errorText={errorText}>
        <LoginInput
          value={value}
          onChange={onChange}
          name={name}
          placeholder={placeholder}
          type={inputType}
          errorText={errorText}
          disabled={disabled}
          userType={type}
        />
        {type === "password" && (
          <EyeImg
            src={showHidePassword ? hideIcon : showIcon}
            alt={showHidePassword ? "hide_icon" : "show_icon"}
            onClick={() => setShowHidePassword(!showHidePassword)}
          />
        )}
      </InputAndPasswordWrapper>
      {errorText && <Error isRounded={true}>{errorText}</Error>}
    </LoginInputWrapper>
  );
};

export default LoginInputfield;

const LoginInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const LoginInput = styled.input`
  outline: none;
  border: none;
  width: calc(100% - 3rem);
  background: transparent;
  border: 1px solid ${Colors.white};
  border-radius: 2.5rem;
  padding: 1rem 1.5rem;
  color: ${Colors.white};
  font-weight: 600;
  font-size: 1rem;
  ::placeholder {
    font-weight: 600;
    font-size: 1rem;
    color: ${Colors.white};
    opacity: 0.2;
  }
  :disabled {
    cursor: not-allowed;
    background: ${Colors.coolGrey};
    opacity: 0.3;
  }
  ${(props) =>
    props.errorText &&
    css`
      border: 1px solid ${Colors.red};
    `}
  ${(props) =>
    props.userType === "password" &&
    css`
      border: none;
    `}
`;
const InputAndPasswordWrapper = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.userType === "password" &&
    css`
      border: 1px solid ${Colors.white};
      border-radius: 2.5rem;
    `}
  ${(props) =>
    props.errorText &&
    css`
      border: 1px solid ${Colors.red};
      border-radius: 2.5rem;
    `}
`;
const EyeImg = styled.img`
  cursor: pointer;
  padding-right: 1rem;
`;
